import type { Exchange } from "@urql/core";
import { cacheExchange, fetchExchange } from "urql";

/**
 * Standard-Urql-Pipeline für Saleor-GraphQL (Auth- und Checkout-Client).
 * `cacheExchange` vor `fetchExchange` (Urql-Empfehlung). Bei Bedarf hier z. B.
 * `@urql/exchange-retry` ergänzen – Retries sind aktuell im `fetch`-Wrapper gelöst.
 */
export function getSaleorUrqlExchanges(): Exchange[] {
	return [cacheExchange, fetchExchange];
}
